import http from "../../http";

const uim = {
    orgHasGroup(param) {
        return http.spin.get("/gateway/chat/app/v2/chat/group/orgHasGroup", param)
    },
    getTargetUserHasGroup(param) {
        return http.spin.get("/gateway/chat/app/v2/chat/group/getTargetUserHasGroup", param)
    },
    generateGroup(param) {
        return http.spin.payload("/gateway/chat/app/v2/chat/group/generateGroup", param)
    },
    searchMessage(param) {
        return http.get("/gateway/chat/app/v2/chat/message/searchMessage", param)
    },
}
export default uim
